module.exports = __webpack_public_path__ + "static/media/dashboardBanner.1594a808.svg";